import { useT } from '@/i18n/LanguageContext';
import { visualizeContent } from '@/i18n/content/visualize';

interface Props {
  triggerCount: number | null;
  deviceCount: number;
  counting?: boolean;
}

export function VizControls({
  triggerCount,
  deviceCount,
  counting = false,
}: Props) {
  const t = useT(visualizeContent).charts;
  return (
    <div
      className="sticky top-0 z-30 backdrop-blur-md border-b bg-sitebg/80 border-sitefg/10"
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex flex-wrap items-center justify-center gap-4">
        <div className="text-xs tracking-wider tabular-nums text-sitefg/60">
          <span className="font-semibold">
            {counting || triggerCount === null ? '—' : triggerCount.toLocaleString()}
          </span>{' '}
          {t.signals} · <span className="font-semibold">{counting ? '—' : deviceCount}</span> {t.sculptures}
        </div>
      </div>
    </div>
  );
}
